import { Alert, Stack } from '@mui/material';

import { AccessGroupClientModel, AccessRequestClientModel, AccessStatus } from '@client-app-sdk';

import { ErrorAlert } from '@common/ui/ErrorAlert';
import { Loader } from '@common/ui/Loader';

import RequestApprovals from '@MyRequests/components/RequestApprovals';
import RequestOverview from '@MyRequests/components/RequestOverview';

import AccessGroups from './AccessGroups';

export interface RequestContentProps {
  isFetched: boolean;
  error: unknown;
  data: AccessRequestClientModel | undefined;
  onDetailsExpand?: (group: AccessGroupClientModel) => void;
  initNewCreds?: boolean;
  isMyAccessEnabled?: boolean;
}

export default function RequestContent({
  isFetched,
  error,
  data,
  onDetailsExpand,
  initNewCreds,
  isMyAccessEnabled,
}: RequestContentProps) {
  if (!isFetched) {
    return <Loader />;
  }

  if (error) {
    return <ErrorAlert error={error} />;
  }

  if (!data) {
    return <Alert severity="error">Request not found</Alert>;
  }

  return (
    <Stack spacing={3}>
      <RequestOverview request={data} />
      {data.challenge && data.challenge.approvers.length ? (
        <RequestApprovals request={data} challenge={data.challenge} />
      ) : null}
      <AccessGroups
        onDetailsExpand={onDetailsExpand}
        initNewCreds={initNewCreds}
        groups={data.access_groups}
        canSeeDetails={data.status.status === AccessStatus.Active || data.status.status === AccessStatus.GRANTED}
        isMyAccessEnabled={isMyAccessEnabled}
      />
    </Stack>
  );
}
